import "core-js/modules/es6.function.name";
import "core-js/modules/es6.object.create";
import "core-js/modules/es6.function.name";

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

import React from 'react';
import Types from '../components/Types';
import CodeInfo from '../components/CodeInfo';

var PropertyTerm =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(PropertyTerm, _React$Component);

  function PropertyTerm() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = PropertyTerm.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        deprecated = _this$props.deprecated,
        name = _this$props.name,
        types = _this$props.types,
        codeInfo = _this$props.codeInfo;
    return React.createElement("h4", {
      className: "title"
    }, deprecated ? React.createElement("span", {
      className: "signiture deprecated"
    }, "deprecated") : null, React.createElement("span", {
      className: "name"
    }, name, ": "), " ", React.createElement(Types, {
      data: types
    }), React.createElement(CodeInfo, {
      data: codeInfo
    }));
  };

  return PropertyTerm;
}(React.Component);

export default PropertyTerm;